import React from 'react'
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap'
import ServiceTabFive from './ServiceOneContainer/ServiceTabFive'
import ServiceTabFour from './ServiceOneContainer/ServiceTabFour'
import ServiceTabOne from './ServiceOneContainer/ServiceTabOne'
import ServiceTabSix from './ServiceOneContainer/ServiceTabSix'
import ServiceTabThree from './ServiceOneContainer/ServiceTabThree'
import ServiceTabTwo from './ServiceOneContainer/ServiceTabTwo'

function ServicesOne() {
    return (
        <Container className='mb-5 mt-5'>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                    <Col className='service_tab_col' xl={4} lg={4} md={5} sm={12} xs={12}>
                        <Nav  variant="pills" className="flex-column mt-3">
                            <Nav.Item>
                                <Nav.Link eventKey="first"> CCTV Installation </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second"> EPABX System </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="three"> Bio Metric </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="four"> Door Cameras </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="five"> AMC & Resource Depoyment </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="six">24x7 Support & Maintenance </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                    <Col xl={8} lg={8} md={7} sm={12} xs={12} >
                        <Tab.Content>
                            <Tab.Pane eventKey="first">
                                <ServiceTabOne />
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                                <ServiceTabTwo />
                            </Tab.Pane>
                            <Tab.Pane eventKey="three">
                                <ServiceTabThree />
                            </Tab.Pane>
                            <Tab.Pane eventKey="four">
                                <ServiceTabFour />
                            </Tab.Pane>
                            <Tab.Pane eventKey="five">
                                <ServiceTabFive />
                            </Tab.Pane>
                            <Tab.Pane eventKey="six">
                                <ServiceTabSix />
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </Container>
    )
}

export default ServicesOne